import type { ComponentProps } from 'react';
import React from 'react';

import { useResponsive } from '../../hooks';
import { ScrollViewWithHeaderTitleXS } from './ScrollViewWithHeaderTitle.xs';
import { ScrollViewWithHeaderTitleSM } from './ScrollViewWithHeaderTitle.sm';

// ────────────────────────────────────────────────────────────────────────────────

export const ScrollViewWithHeaderTitle = React.forwardRef(
  (props: ScrollViewWithHeaderTitleProps, ref) => {
    const { minWidth } = useResponsive();

    if (minWidth.isSM) {
      return <ScrollViewWithHeaderTitleSM ref={ref} {...props} />;
    }

    return <ScrollViewWithHeaderTitleXS ref={ref} {...props} />;
  },
);

// ────────────────────────────────────────────────────────────────────────────────

type ScrollViewWithHeaderTitleProps = ComponentProps<
  typeof ScrollViewWithHeaderTitleXS
> &
  ComponentProps<typeof ScrollViewWithHeaderTitleSM>;
